import { combineReducers } from "redux";
import torreFracionados from "./slices/torreFracionados.slice";

const reducer = combineReducers({
  torreFracionados,
});

export default reducer;
